// extracted by mini-css-extract-plugin
module.exports = {"svg":"right-down-arrow-module--svg---tCg3"};